import { PropertyChangedInformation, Notification } from '@app/shared';
import { BasicCompanyInformation } from '@app/security-common';

@Notification({
    name: 'ProgramUpdatedNotification'
})
export class ProgramUpdatedNotification {
    public programId: string;
    public programName: string | null;
    public company: BasicCompanyInformation;
    public changes: PropertyChangedInformation[] = [];
}

@Notification({
    name: 'ProgramCreatedNotification'
})
export class ProgramCreatedNotification {
    public programId: string;
    public programName: string | null;
    public company: BasicCompanyInformation;
    public changes: PropertyChangedInformation[] = [];
}